import {useTranslation} from '@aboutyou/i18n';
import {ErrorPageInline} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import styled from 'styled-components';

export const NavigationDataError: FC = () => {
  const {t} = useTranslation();
  return (
    <ErrorPageInline
      headline={t('Sorry, an unexpected error occurred')}
      RowComp={MessageContainer}
    />
  );
};

const MessageContainer = styled.div`
  padding: 2rem;
`;
